import { BadgeWithTooltip } from 'components/WithTooltip/BadgeWithTooltip';
import type { WorkOrderPriceItem } from 'gql/graphql';
import { IconWarning } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';

interface ISeasonCostRenderer extends ICellRendererParams<WorkOrderPriceItem> {
    seasonId: number;
}

export const SeasonCostRenderer = (props: ISeasonCostRenderer) => {
    const { value, data, seasonId } = props;

    if (!data) {
        return '';
    }

    const { errors, hasErrors } = data?.seasonValues?.find((season) => season.seasonId === seasonId) ?? {};

    if (hasErrors && errors) {
        return (
            <BadgeWithTooltip
                messages={errors}
                size="l"
                badgeSize="s"
                label="Ошибка"
                status="error"
                iconLeft={IconWarning}
            />
        );
    }

    return value;
};

SeasonCostRenderer.displayName = 'SeasonVolumeRenderer';
